import { FC } from 'react';
import { Typography, Button } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuthContext } from '@/providers';
import { Flex } from '@/components';

export const NoAccessPage: FC = () => {
	const { signOut } = useAuthContext();

	return (
		<Flex
			column
			sx={{ alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 2 }}
		>
			<LockOutlinedIcon sx={{ fontSize: 64, color: 'text.secondary' }} />
			<Typography variant="h5" sx={{ fontWeight: 600 }}>
				Acces interzis
			</Typography>
			<Typography
				variant="body2"
				color="text.secondary"
				sx={{ maxWidth: '360px', textAlign: 'center' }}
			>
				Contul tau nu are permisiunile necesare pentru a accesa aceasta aplicatie.
				Contacteaza un administrator.
			</Typography>
			<Button variant="outlined" onClick={signOut}>
				Deconectare
			</Button>
		</Flex>
	);
};
